// /DeviceConfigs/helpers/buildInitialFormValues.js
export function buildInitialFormValues(raw, events) {
    if (!raw) return {};

    // participantTypesDisabled -> participantType_<id>: true
    const participantTypesDisabled = raw.participantTypesDisabled || [];
    const participantTypeSwitches = participantTypesDisabled.reduce((acc, id) => {
        acc[`participantType_${id}`] = true;
        return acc;
    }, {});

    // CustomFields -> CustomSeatFieldIds (groupId only)
    const selectedCustomSeatFieldIds =
        raw?.CustomFields?.map(f => f.groupId) || [];

    const initialObj = {
        ...raw,

        // We normalise things that come in objects/ids in DB.
        SelectedEventId: raw?.SelectedEventId?._id || null,

        // defaults
        Mode: raw?.Mode ?? 'entranceControl',
        AutoCheckInMilliSeconds: raw?.AutoCheckInMilliSeconds ?? 1250,
        PrintScreenMilliSeconds: raw?.PrintScreenMilliSeconds ?? 2500,
        IsShowVersionEnabled: raw?.IsShowVersionEnabled ?? true,

        // theme boolean for switch
        theme: String(raw?.Theme).toLowerCase() === 'dark' || raw?.Theme === true,

        // Type fallback
        Type: raw?.Type ?? 'mobile',

        // Cloakroom defaults
        CloakroomTagStart: raw?.CloakroomTagStart ?? 1,
        CloakroomTagCurrent: raw?.CloakroomTagCurrent ?? null,

        // override server
        ServerOverrideUrl: raw?.ServerOverrideUrl || undefined,

        // seat fields
        CustomSeatFieldIds: selectedCustomSeatFieldIds,

        ...participantTypeSwitches,
    };

    // Visible EFN depends on the selected event
    const ev = events?.find(e => e._id === initialObj.SelectedEventId);
    const showEFN = ev?.countryPK === 'DE';

    return { initialObj, showEFN };
}
